<template>
  <div class="modelTips">
    <!-- 提示弹窗 -->
    <mu-dialog :open.sync="showTips" width="300px" :overlay-close="false" :append-body="false" :overlay="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p>{{ msge }}</p>
      </div>
      <div class="dl-footer dl-f-center">
        <mu-button full-width :color="themeConfig.dark" text-color="#fff" @click="hide">确 定</mu-button>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'modelTips',
  props: {
    showTips: {
      type: Boolean,
      default: false
    },
    msge: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'themeConfig'
    ])
  },
  methods: {
    hide () {
      this.$emit('update:showTips', false)
    }
  }
}
</script>

<style lang="less" scoped>
.dl-title {
  font-size: 20px;
  color: #333;
  width: 100%;
  font-weight: 600;
  text-align: center;
  position: relative;
  .back-icon {
    font-size: .56rem;
    color: #CCCBCA;
    position: absolute;
    left: 4px;
    top: 3px;
  }
}
.dl-content {
  font-size: .2rem;
  color: #333;
  line-height: .36rem;
  letter-spacing: .06rem;
  text-align: center;
  .dl-c-title {
    padding-bottom: .2rem;
    font-size: .26rem;
    font-weight: 800;
  }
}
.dl-footer {
  display: flex;
  justify-content: space-between;
}
.dl-f-center {
  justify-content: center;
}
.mb20 {
  margin-bottom: .2rem;
}
@media screen and (max-width:450px) {
  .dl-title {
    font-size: .36rem;
  }
}
</style>
